import { Outlet } from '@tanstack/react-router';
import Brand from '@/shared/ui/Brand';
import ThemePill from '@/shared/ui/ThemePill';

// The centered card every SSO screen except the dashboard renders in.
export default function SsoLayout() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-background-main p-2xl max-md:px-l max-md:pt-16 max-md:pb-l">
      <div className="relative flex w-105 max-w-full flex-col gap-2xl overflow-hidden rounded-md bg-background-secondary p-3xl max-md:p-2xl">
        <Brand />
        <Outlet />
      </div>
      <ThemePill fixed />
    </div>
  );
}
